export const productAccessoriesOptions = (instance, options) => {
    let responsiveItemCounts = {
        768: 2,
        1280: 3,
    }

    let breakpoints = {}
    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: 40,
            grid: {
                rows: 1,
            },
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        grid: {
            rows: 3,
        },
        breakpoints: breakpoints,
    }
}